import { Select, SelectProps } from '@mantine/core';
import { UserAlertFrequency } from '../../../../../backend/src/types.generated';

const REMINDER_FREQUENCY_OPTIONS = [
	{ value: UserAlertFrequency.Weekly, label: 'Weekly' },
	{ value: UserAlertFrequency.Fortnightly, label: 'Fortnightly' },
	{ value: UserAlertFrequency.Monthly, label: 'Monthly' },
];

export const ReminderFrequencyInput = (props: SelectProps) => {
	return <Select data={REMINDER_FREQUENCY_OPTIONS} {...props} />;
};
